// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"123":"43e440ea","716":"0a034f5d"}[chunkId] + ".chunk.js");